import React, { ReactNode } from 'react';
import Avatar from 'src/components/Avatar';
import Skeleton from 'src/components/Skeleton/Skeleton';
import { onRequestPhoneCall } from 'src/helpers/validationHelper';
import './SrDetailContact.scss';

interface SrDetailContactProps {
  name: ReactNode;
  role?: string;
  email?: string;
  phone?: string;
  avatar?: ReactNode;
  loading?: boolean;
}

const SrDetailContact = ({
  name,
  role,
  email,
  phone,
  avatar,
  loading,
}: SrDetailContactProps) => {
  if (loading) {
    return (
      <div className="sr-detail-contact">
        <Avatar loading badge={undefined} size={undefined} url={undefined} />
        <div className="sr-detail-contact-details-loading">
          <Skeleton variant="text" width="100%" />
          <Skeleton variant="text" width="75%" />
        </div>
      </div>
    );
  }

  return (
    <div className="sr-detail-contact">
      {avatar}
      <div className="sr-detail-contact-details">
        <div className="sr-detail-contact-name">{name}</div>
        {role && <div className="sr-detail-contact-line">{role}</div>}
        {email && <div className="sr-detail-contact-line">{email}</div>}
        {phone && (
          <div className="sr-detail-contact-line">
            {onRequestPhoneCall(phone)}
          </div>
        )}
      </div>
    </div>
  );
};

export default SrDetailContact;
